export type RewardEventKind =
  | 'checkin'
  | 'verification'
  | 'add_photo'
  | 'write_review'
  | 'report_condition'
  | 'publish_route'
  | 'share_route';

export interface RewardEventPayload {
  kind: RewardEventKind;
  title: string;
  message: string;
  rewardPoints: number;
}

export const REWARD_EVENT_NAME = 'fricamp:reward-event';

export function emitRewardEvent(payload: RewardEventPayload) {
  window.dispatchEvent(new CustomEvent<RewardEventPayload>(REWARD_EVENT_NAME, { detail: payload }));
}
